<template>
  <table class="total-table">
    <tbody>
      <!-- [Diagnostic Types] -->
      <tr>
        <th class="total-table--header" :rowspan="getDiagnosticTypesSize + 1">{{$t('headers.repairTypesTotal')}}</th>
      </tr>
      <tr v-for="(r, i) in getDiagnosticTypes.rows" :key="i + 100">
        <td class="total-table--row"><em>{{r}}</em></td>
      </tr>

      <!-- [Repair Types] -->
      <tr>
        <th class="total-table--header" :rowspan="getRepairTypesSize + 1">{{$t('headers.repairTypesTotal')}}</th>
      </tr>
      <tr v-for="(r, i) in getRepairTypes.rows" :key="i + 200">
        <td class="total-table--row"><em>{{r}}</em></td>
      </tr>

      <!-- [Parts Used/Parts Types] -->
      <tr>
        <th class="total-table--header" :rowspan="getPartsTypesSize + 1">{{$t('headers.partsUsedTotal')}}</th>
      </tr>
      <tr v-for="(r, i) in getPartsTypes.rows" :key="i + 300">
        <td class="total-table--row"><em>{{r}}</em></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { getTotalOfTypesForMultipleRowsPreview } from "@/services/partsPreviewService"
export default {
  props: {
    parts: {
      type: Array,
      required: true
    }
  },
  computed: {
    getDiagnosticTypes() {
      return this.getTotalOfTypes('diagnosticTypes')
    },
    getDiagnosticTypesSize() {
      return this.getDiagnosticTypes.rows.length
    },
    getRepairTypes() {
      return this.getTotalOfTypes('repairTypes')
    },
    getRepairTypesSize() {
      return this.getRepairTypes.rows.length
    },
    getPartsTypes() {
      return this.getTotalOfTypes('partsTypes')
    },
    getPartsTypesSize() {
      return this.getPartsTypes.rows.length
    }
  },
  methods: {
    getTotalOfTypes(prop) {
      return getTotalOfTypesForMultipleRowsPreview(prop, this.parts, c => this.$t(c))
    }
  }
}
</script>

<style scoped>
table.total-table {
  max-width: 37rem;
}

table.total-table > tbody > tr > td.total-table--row {
  color: #464646;
  font-family: 'Titillium Web', sans-serif;
  font-weight: 400;
  font-size: 0.9rem;
  letter-spacing: 1px;
  background-color: rgba(0, 0, 0, 0.02);
  border-left: white 1px solid !important;
  border-right: white 1px solid !important;
  border-top: 1px solid #dee2e6 !important;
  
  height: 2.3rem;

  position: relative;
  top: -2px;
}

table.total-table > tbody > tr > .total-table--header {
  border-left: white 1px solid;
  border-right: white 1px solid;
  background-color: #cfd8dc !important;
  height: 2.3rem;
  width: 12rem;

  color: #000000;
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
  font-size: 0.9rem;
  letter-spacing: 1px;
}
table.total-table > tbody > tr > td, th {
  padding: 0px 16px;
  text-align: start;
}
</style>